import { render, staticRenderFns } from "./Institute.vue?vue&type=template&id=0635fd8a"
import script from "./Institute.vue?vue&type=script&lang=js"
export * from "./Institute.vue?vue&type=script&lang=js"
import style0 from "./Institute.vue?vue&type=style&index=0&id=0635fd8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports